import CloudLogo from '../../../../../toolkit/core-kit/assets/mellow-mark.svg?react';

import styles from './index.module.scss';

function Topbar() {
  return (
    <div className={styles.topbar}>
      <CloudLogo className={styles.logo} />
    </div>
  );
}

export default Topbar;
